/**
 * Created by jiachenpan on 16/11/18.
 */

/* 合法uri*/
export function validateURL(textval) {
  const urlregex = /^(https?|ftp):\/\/([a-zA-Z0-9.-]+(:[a-zA-Z0-9.&%$-]+)*@)*((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9][0-9]?)(\.(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9]?[0-9])){3}|([a-zA-Z0-9-]+\.)*[a-zA-Z0-9-]+\.(com|edu|gov|int|mil|net|org|biz|arpa|info|name|pro|aero|coop|museum|[a-zA-Z]{2}))(:[0-9]+)*(\/($|[a-zA-Z0-9.,?'\\+&%$#=~_-]+))*$/;
  return urlregex.test(textval);
}

/* 小写字母*/
export function validateLowerCase(str) {
  const reg = /^[a-z]+$/;
  return reg.test(str);
}

/* 大写字母*/
export function validateUpperCase(str) {
  const reg = /^[A-Z]+$/;
  return reg.test(str);
}

/* 大小写字母*/
export function validateAlphabets(str) {
  const reg = /^[A-Za-z]+$/;
  return reg.test(str);
}

/**
 * validate email
 * @param email
 * @returns {boolean}
 */
export function validateEmail(email) {
  const re = /^([a-zA-Z0-9]+[_|-|.]?)*[a-zA-Z0-9]+@([a-zA-Z0-9]+[_|-|.]?)*[a-zA-Z0-9]+.[a-zA-Z]{2,3}$/gi;
  return re.test(email);
}
//邮政编码
export function validateZipCode(ZipCode) {
  const re = /^[1-9][0-9]{5}$/;
  return re.test(ZipCode);
}
//传真
export function validateFaxNum(FaxNum) {
  const re = /^(\d{3,4}-)?\d{7,8}$/;
  return re.test(FaxNum);
}
//电话号
export function validateStandPhone(FaxNum) {
  const re = /^(\(\d{3,4}\)|\d{3,4}-|\s)?\d{7,14}$/;
  return re.test(FaxNum);
}
// 验证所有电话
export function validateAllPhone(phone) {
  const mobile = /^1[0-9]\d{9}$/;
  const tel = /^(\(\d{3,4}\)|\d{3,4}-|\s)?\d{7,8}$/;
  return mobile.test(phone) || tel.test(phone);
}
// 手机号验证
export function validatePhone(phone) {
  const re = /^1[0-9]\d{9}$/;
  return re.test(phone);
}

// 身份证号验证
export function validateIdCardNumber(idCardNumber) {
  const re = /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/;
  return re.test(idCardNumber);
}

//是否数字 /(^[\-0-9][0-9]*(.[0-9]+)?)$/ (小数,正负数)
export function validateNumber(number) {
  const re = /^[0-9]*$/; //正整数
  return re.test(number);
}
//正数不带小数点这个好用
export function NumberPower(number) {
  const re = /^[+]{0,1}(\d+)$/; //正整数
  return re.test(number);
}

export function fixedNumber(number) {
  const re = /^[0-9]+(.[0-9]{0,4})?$/; //四位小数正整数
  return re.test(number);
}
export function fixedNumber2(number) {
  const re = /^(\+|\-)?((([1-9]([0-9]*))|0)(\.[0-9]{0,2})?)?$/; //两位小数正整数
  return re.test(number);
}

export function fixedNumber3(number) {
  const re = /^(?!0+(?:\.0+)?$)(?:[1-9]\d*|0)(?:\.\d{1,2})?$/; //两位小数正整数
  return re.test(number);
}
export function fixedNumber4(number) {
  const re = /^[0-9]+(.[0-9]{1,2})?$/; //大于或等于0的两位小数
  return re.test(number);
}
export function fixedNumber5(number) {
  const re = /^(?!0+(?:\.0+)?$)(?:[1-9]\d*|0)(?:\.\d{1,4})?$/; //四位小数正整数
  return re.test(number);
}
//密码长度最少6位，且必应同时包含大小写字母、特殊符号、数字
export function validateUsername(number) {
  const reg = /^(?=.*[0-9])(?=.*[a-zA-Z])(?=.*[^a-zA-Z0-9]).{8,30}$/; //正整数
  return reg.test(number);
}
//密码长度最少6位，且必应同时包含大小写字母、特殊符号、数字
export function validatePassword(number) {
  const reg = /^[a-zA-Z0-9]{6,14}$/; //正整数
  return reg.test(number);
}
//验证大小写与数字
export function validateAlphabetsNumber(number) {
  const reg = /^[A-Za-z0-9]+$/;
  return reg.test(number);
}
//验证汉字
export function validateChinese(number) {
  const reg = /[\u4e00-\u9fa5]{2,7}/g;
  return reg.test(number);
}

//验证护照
export function validatePassport(number) {
  const reg1 = /^[a-zA-Z]{5,17}$/;
  const reg2 = /^[a-zA-Z0-9]{5,17}$/;
  return reg1.test(number) || reg2.test(number);
}

//验证港澳居民来往大陆通行证
export function validateHKMAKAO(number) {
  const reg = /^[HMhm]{1}([0-9]{10}|[0-9]{8})$/;
  return reg.test(number);
}

//验证台湾居民来往大陆通行证
export function validateTAIWAN(number) {
  const reg1 = /^[0-9]{10}$/;
  const reg2 = /^[0-9]{8}$/;
  return reg1.test(number) || reg2.test(number);
}